/**
 *
 * ListFilters
 *
 */

import FormControl from '@material-ui/core/FormControl'
import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import SecondaryAppbar from '../Tab/SecondaryTab/SecondaryAppbar'
import SecondaryTab from '../Tab/SecondaryTab/SecondaryTab'
import SecondaryTabs from '../Tab/SecondaryTab/SecondaryTabs'
import DropdownFilter from './DropdownFilter'
import filterDataOne from './fixtures/fixtureOne.json'
import filterDataThree from './fixtures/fixtureThree.json'
import filterDataTwo from './fixtures/fixtureTwo.json'
import messages from './messages'

// import * as formatFunctions from 'helpers/functions';

const styles = theme => ({
  root: {
    display: 'inline-block',
    flexWrap: 'wrap',
    width: '100%',
    float: 'left',
    backgroundColor: theme.colors.white,
    '& .active': {
      backgroundColor: `${theme.palette.secondary.main}! important`,
      color: `${theme.colors.white}! important`,
    },
    '& .inactive': {
      backgroundColor: theme.colors.white,
    },
  },
  formControl: {
    border: '1px solid #ccc',
    width: '100%',
    borderRadius: '5px',
    backgroundColor: theme.colors.white,
    position: 'relative',
  },
  paper: {
    position: 'absolute',
    top: 40,
    right: 0,
    width: '425px',
    background: '#F3F3F3',
    padding: '25px',
    zIndex: '1',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  fontColorBlue: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
  },
  stgSelect: {
    background: 'none',
    '&:before': {
      borderBottom: 'none !important',
    },
    '&:after': {
      background: 'none',
      borderBottom: 'none !important',
    },
    '&:focus': {
      background: 'none',
      borderBottom: 'none !important',
    },
    '&:hover': {
      borderBottom: 'none',
    },
    '& div>div': {
      width: '100%',
      boxSizing: 'border-box',
      padding: '10px',
      fontSize: '14px',
    },
  },
  info: {
    color: theme.status.disabledColor,
  },
})

/* eslint-disable react/prefer-stateless-function */
class PopupFilters extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: {
        genderName: '',
        primaryCompetitionLevel: {},
        secondaryCompetitionLevel: {},
        age: {},
      },
      open: false,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isOpenOverlay !== this.props.isOpenOverlay) {
      const { open } = this.state
      this.setState({ open: !open })
    }
  }

  handleClick = () => {
    const { isOpenCallback } = this.props
    const { open } = this.state
    this.setState({ open: !open })
    isOpenCallback(!open)
  }

  handleClickAway = () => {
    this.setState({
      open: false,
    })
  }

  handleChange = (key, value) => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const selected = { ...this.state.selected }
    selected[key] = value
    this.setState({ selected })
    this.props.onChange(selected)
  }

  render() {
    const { classes, filterDataPrimary, filterDataSecondry, filterDataAge, gender } = this.props
    const { age, genderName, primaryCompetitionLevel, secondaryCompetitionLevel } = this.state.selected
    const { open } = this.state

    return (
      <div className={classes.root}>
        <FormControl className={classes.formControl}>
          <Select value="" displayEmpty name="camp" onClick={this.handleClick} readOnly className={classes.stgSelect}>
            <MenuItem value="">Comp Characterstics</MenuItem>
          </Select>
          {open ? (
            <div className={classes.paper}>
              <Grid container spacing={8}>
                <Grid item xs={12} className={classes.fontColorBlue}>
                  <FormattedMessage {...messages.levelOne} />
                </Grid>
                <Grid container spacing={8}>
                  <Grid item xs={12} sm={6}>
                    <DropdownFilter
                      onChange={data => {
                        this.handleChange('primaryCompetitionLevel', data)
                      }}
                      selected={primaryCompetitionLevel}
                      filterData={filterDataPrimary}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DropdownFilter
                      onChange={data => {
                        this.handleChange('secondaryCompetitionLevel', data)
                      }}
                      selected={secondaryCompetitionLevel}
                      filterData={filterDataSecondry}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} className={classes.fontColorBlue}>
                  <FormattedMessage {...messages.levelTwo} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <DropdownFilter
                    onChange={data => {
                      this.handleChange('age', data.Ages)
                    }}
                    selected={age}
                    filterData={filterDataAge}
                  />
                </Grid>
                <Grid item xs={12} className={classes.fontColorBlue}>
                  <FormattedMessage {...messages.levelThree} />
                </Grid>
                <Grid item xs={12}>
                  <SecondaryAppbar position="static">
                    <SecondaryTabs>
                      <SecondaryTab
                        value=""
                        label="All"
                        onClick={() => {
                          this.handleChange('genderName', '')
                        }}
                        active={genderName === ''}
                      />
                      {/* {gender.length < 1 && <p className={classes.info}><FormattedMessage {...messages.competitionSelectInfo} /></p>} */}
                      {gender.indexOf('Mixed') !== -1 && (
                        <SecondaryTab
                          value="Mixed"
                          label="Mixed"
                          onClick={() => {
                            this.handleChange('genderName', 'Mixed')
                          }}
                          active={genderName === 'Mixed'}
                        />
                      )}
                      {gender.indexOf('Male') !== -1 && (
                        <SecondaryTab
                          value="Male"
                          label="Male"
                          onClick={() => {
                            this.handleChange('genderName', 'Male')
                          }}
                          active={genderName === 'Male'}
                        />
                      )}
                      {gender.indexOf('Female') !== -1 && (
                        <SecondaryTab
                          value="Female"
                          label="Female"
                          onClick={() => {
                            this.handleChange('genderName', 'Female')
                          }}
                          active={genderName === 'Female'}
                        />
                      )}
                    </SecondaryTabs>
                  </SecondaryAppbar>
                </Grid>
              </Grid>
            </div>
          ) : null}
        </FormControl>
      </div>
    )
  }
}

PopupFilters.defaultProps = {
  filterDataPrimary: filterDataOne,
  filterDataSecondry: filterDataTwo,
  filterDataAge: filterDataThree,
  gender: ['Mixed', 'Male', 'Female'],
  onChange: () => {},
}
export default withStyles(styles)(PopupFilters)
